import api from './api';
import {
  MileageCard,
  CreateMileageCardRequest,
  UpdateMileageCardRequest,
  MileageBalance,
  MileageCardCredentials,
  MileagePurchase,
  CreateMileagePurchaseRequest,
  UpdateMileagePurchaseRequest,
  MileageUsage,
  AttachCheckoutUsageRequest,
  MileageUsageWithCard,
} from '../interfaces/MileageCard';

export const mileageCardService = {
  // ---------- Cartões ----------
  async getCards(airline?: string): Promise<MileageCard[]> {
    const response = await api.get('/read/mileage-cards', {
      params: airline ? { airline } : undefined,
    });
    return response.data;
  },

  async getCardById(id: string): Promise<MileageCard> {
    const response = await api.get(`/read/mileage-cards/${id}`);
    return response.data;
  },

  async getBalance(id: string): Promise<MileageBalance> {
    const response = await api.get(`/read/mileage-cards/${id}/balance`);
    return response.data;
  },

  async getCredentials(id: string): Promise<MileageCardCredentials> {
    const response = await api.get(`/read/mileage-cards/${id}/credentials`);
    return response.data;
  },

  async createCard(data: CreateMileageCardRequest): Promise<MileageCard> {
    const response = await api.post('/write/mileage-cards', data);
    return response.data;
  },

  async updateCard(
    id: string,
    data: UpdateMileageCardRequest,
  ): Promise<MileageCard> {
    const response = await api.patch(`/write/mileage-cards/${id}`, data);
    return response.data;
  },

  async deleteCard(id: string): Promise<void> {
    await api.delete(`/write/mileage-cards/${id}`);
  },

  // ---------- Compras ----------
  async getPurchases(cardId: string): Promise<MileagePurchase[]> {
    const response = await api.get(`/read/mileage-cards/${cardId}/purchases`);
    return response.data;
  },

  async createPurchase(
    cardId: string,
    data: CreateMileagePurchaseRequest,
  ): Promise<MileagePurchase> {
    const response = await api.post(
      `/write/mileage-cards/${cardId}/purchases`,
      data,
    );
    return response.data;
  },

  async updatePurchase(
    purchaseId: string,
    data: UpdateMileagePurchaseRequest,
  ): Promise<MileagePurchase> {
    const response = await api.patch(
      `/write/mileage-cards/purchases/${purchaseId}`,
      data,
    );
    return response.data;
  },

  async deletePurchase(purchaseId: string): Promise<void> {
    await api.delete(`/write/mileage-cards/purchases/${purchaseId}`);
  },

  // ---------- Usos (visualização no cartão) ----------
  async getUsages(cardId: string): Promise<MileageUsage[]> {
    const response = await api.get(`/read/mileage-cards/${cardId}/usages`);
    return response.data;
  },

  // ---------- Usos atrelados ao checkout (emissão) ----------
  async getUsagesByCheckout(
    checkoutId: string,
  ): Promise<MileageUsageWithCard[]> {
    const response = await api.get(
      `/read/checkout/${checkoutId}/mileage-usages`,
    );
    return response.data;
  },

  async attachUsageToCheckout(
    checkoutId: string,
    data: AttachCheckoutUsageRequest,
  ): Promise<MileageUsage> {
    const response = await api.post(
      `/write/checkout/${checkoutId}/mileage-usages`,
      data,
    );
    return response.data;
  },

  async detachUsageFromCheckout(usageId: string): Promise<void> {
    await api.delete(`/write/checkout/mileage-usages/${usageId}`);
  },
};
